import { gql } from '__generated__';

export default gql(`
  mutation EditTicketNumberSequence($input: EditTicketNumberSequenceInput!) {
    editTicketNumberSequence(input: $input) {
      ...TicketNumberSequenceAttributes
    }
  }
`);
